import dayjs from "dayjs";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { ReportData } from "../../models/report_data";
import { IGetReportNovosNegociosListaUseCase } from "../../../presentation/useCases/read/get_report_novos_negocios_lista_use_case";

export type GetReportNovosNegociosListaParams = {
  requiredMimeType: ReportMimeType | null;
  centroCusto?: number[] | null;
  titulo?: string | null;
  status?: number[] | null;
  dataDe?: Date | null;
  dataAte?: Date | null;
  colunas?: {
    nroNegocio: boolean;
    data: boolean;
    cliente: boolean;
    cidade: boolean;
    telefone: boolean;
    nroEdital: boolean;
    centroCusto: boolean;
    informacoes: boolean;
  } | null
};


export class GetReportNovosNegociosListaUseCase implements IGetReportNovosNegociosListaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(params: GetReportNovosNegociosListaParams): Promise<ReportData> {

    const centroCustoStr = params.centroCusto?.length ? params.centroCusto.filter(x => x !== 0).join(',') : null;
    const statusStr = params.status ? params.status.filter(x => x !== 4).join(',') : null;

    const response = await this.repository.getReportNovosNegociosLista({
      centroCusto: centroCustoStr != '' ? centroCustoStr : null,
      titulo: params.titulo || null,
      status: statusStr != '' ? statusStr : null,
      dataDe: params.dataDe || null,
      dataAte: params.dataAte || null,
      requiredMimeType: params.requiredMimeType || null,
      colunas: params.colunas || null,

    })

    if (response.mimeType !== 'text/html') {
      const arquivoData = response.bytes;
      const arquivoNome = `novos_negocios_lista_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
